import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import { getDietaryRestrictions } from '@hungryroot/rest/api/v2/dietary-restrictions/get/get-dietary-restrictions';

const timeLimit = 15 * 60 * 1000;

const getDietaryRestrictionsQueryKey = () => ['dietary_restrictions'];

/** Get all of the possible dietary restrictions */
export function useDietaryRestrictions(
  options?: Pick<UseQueryOptions, 'enabled'>
) {
  return useQuery({
    queryKey: getDietaryRestrictionsQueryKey(),
    queryFn: async () => {
      const resp = await getDietaryRestrictions();

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    retry: false,
    enabled: options?.enabled,
    gcTime: timeLimit,
    staleTime: timeLimit,
  });
}
